import { createContext } from "react";

const ExcelTableContext = createContext({});

export default ExcelTableContext;
